import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {window} from 'ssr-window';
import Button from '@spothero/ui/button';
import TextButton from '@spothero/ui/text-button';

export default class SearchActions extends Component {
    static propTypes = {
        showCancel: PropTypes.bool,
        isSearching: PropTypes.bool,
        isValidStart: PropTypes.bool,
        searchButtonText: PropTypes.string,
        addKeyListeners: PropTypes.bool,
        onSearchClick: PropTypes.func.isRequired,
        onCancelClick: PropTypes.func,
    };
    static defaultProps = {
        searchButtonText: 'Search',
    };

    componentDidMount() {
        this._manageKeyListeners();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.addKeyListeners !== this.props.addKeyListeners) {
            this._manageKeyListeners();
        }
    }

    componentWillUnmount() {
        this._manageKeyListeners(true);
    }

    _onKeyDown = evt => {
        const {onSearchClick, onCancelClick} = this.props;

        if (evt.which === 13) {
            // enter
            evt.preventDefault();

            onSearchClick();
        } else if (evt.which === 27) {
            // escape
            evt.preventDefault();

            if (onCancelClick) {
                onCancelClick();
            }
        }
    };

    _manageKeyListeners(forceRemove) {
        const {addKeyListeners} = this.props;

        if (forceRemove || !addKeyListeners) {
            // remove key listeners for update and cancel buttons
            window.removeEventListener('keydown', this._onKeyDown);
        } else if (addKeyListeners) {
            // add key listeners for update and cancel buttons
            window.addEventListener('keydown', this._onKeyDown);
        }
    }

    render() {
        const {
            showCancel,
            isSearching,
            isValidStart,
            searchButtonText,
            onCancelClick,
            onSearchClick,
        } = this.props;

        return (
            <div className="SearchActions">
                <Button
                    className="SearchActions-submit"
                    color="primary"
                    loading={isSearching}
                    disabled={!isValidStart || isSearching}
                    onClick={onSearchClick}
                >
                    {searchButtonText}
                </Button>
                {showCancel && (
                    <TextButton
                        className="SearchActions-cancel"
                        disabled={isSearching}
                        block
                        onClick={onCancelClick}
                    >
                        Cancel
                    </TextButton>
                )}
            </div>
        );
    }
}
